import LineHotAirBalloonIcon from 'LuxKit/Icons/line/LineHotAirBalloonIcon'
import SolidBedIcon from 'LuxKit/Icons/solid/SolidBedIcon'
import SolidCarSideviewIcon from 'LuxKit/Icons/solid/SolidCarSideviewIcon'
import SolidCompassIcon from 'LuxKit/Icons/solid/SolidCompassIcon'
import SolidPlaneDepartureIcon from 'LuxKit/Icons/solid/SolidPlaneDepartureIcon'
import SolidShieldCheckIcon from 'LuxKit/Icons/solid/SolidShieldCheckIcon'
import SolidShipIcon from 'LuxKit/Icons/solid/SolidShipIcon'
import SolidStarIcon from 'LuxKit/Icons/solid/SolidStarIcon'
import LinePlusIcon from 'LuxKit/Icons/line/LinePlusIcon'
import SvgIcon from 'LuxKit/SvgIcon'

const LOYALTY_PRODUCT_TYPE_ICON_MAP: Record<App.LoyaltyProductType, typeof SvgIcon> = {
  hotel_flash: SolidBedIcon,
  hotel_lpc: SolidBedIcon,
  hotel_lpp_eps: SolidBedIcon,
  rental: SolidBedIcon,
  le_tour: SolidCompassIcon,
  tour_bank: SolidCompassIcon,
  trusted_partner_tour: SolidCompassIcon,
  cruise_group_1: SolidShipIcon,
  cruise_group_2: SolidShipIcon,
  cruise_group_3: SolidShipIcon,
  experience: LineHotAirBalloonIcon,
  tour_optional_extra: LineHotAirBalloonIcon,
  insurance: SolidShieldCheckIcon,
  cfmr: SolidShieldCheckIcon,
  dom_economy: SolidPlaneDepartureIcon,
  dom_business: SolidPlaneDepartureIcon,
  int_economy: SolidPlaneDepartureIcon,
  int_first: SolidPlaneDepartureIcon,
  int_business: SolidPlaneDepartureIcon,
  int_premium_economy: SolidPlaneDepartureIcon,
  car_hire: SolidCarSideviewIcon,
  lux_plus: LinePlusIcon,
}

function getLoyaltyProductTypeIcon(
  loyaltyProductType: App.LoyaltyProductType | undefined,
): typeof SvgIcon {
  if (!loyaltyProductType) return SolidStarIcon
  return LOYALTY_PRODUCT_TYPE_ICON_MAP[loyaltyProductType]
}

export default getLoyaltyProductTypeIcon
